export var MOST_NEGATIVE_SINGLE_FLOAT = -3.4028234663852886e38;
export var MOST_POSITIVE_SINGLE_FLOAT = -MOST_NEGATIVE_SINGLE_FLOAT;